export default Object.freeze({
  root: () => '/',
  unauthed: Object.freeze({
    confirm: () => '/confirm',
    confirmEmail: () => '/confirm-email',
    forgotPassword: () => '/forgot',
    forgotPasswordEmail: () => '/forgot-email',
    forgotPasswordSuccess: () => '/forgot-success',
    login: () => '/login',
    register: () => '/register',
    resetPassword: () => '/reset-password',
    resetPasswordFailure: () => '/invalid-code',
    resetPasswordSuccess: () => '/reset-success',
  }),
  authed: Object.freeze({
    lists: () => '/lists',
    confirm: () => '/confirm',
    console: () => '/console',
    quickStart: () => '/quickstart',
    profile: () => '/profile',
    faq: () => '/faq',
  }),
});
